const EXITED_KEY = 'teamf-824-beta-nav-exited';

export type BetaNavStatus = 'active' | 'exited';

export const hasExitedBetaNav = (): boolean => {
  try {
    return localStorage.getItem(EXITED_KEY) === '1';
  } catch {
    return false;
  }
};

export const setBetaNavExited = (exited: boolean): void => {
  try {
    if (exited) {
      localStorage.setItem(EXITED_KEY, '1');
    } else {
      localStorage.removeItem(EXITED_KEY);
    }
  } catch {
    return;
  }
};

export const betaNavStatus = (): BetaNavStatus => (hasExitedBetaNav() ? 'exited' : 'active');
